import {
	type OrderExaminationCreateDto,
	postExaminations,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const examinationMutationsResource = Resources.base.examination.mutations;

export const useCreateOrderExaminationMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((data: OrderExaminationCreateDto) =>
			postExaminations(data),
		),
		onError: (error) => {
			console.error(
				`${t(examinationMutationsResource.createExaminationError)}:`,
				error,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) });
			toast.success(t(examinationMutationsResource.updateExaminationSuccess));
		},
	});
};
